import { render, staticRenderFns } from "./ItemPanel.vue?vue&type=template&id=bc5e9a46&"
import script from "./ItemPanel.vue?vue&type=script&lang=js&"
export * from "./ItemPanel.vue?vue&type=script&lang=js&"
import style0 from "./ItemPanel.vue?vue&type=style&index=0&id=bc5e9a46&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc5e9a46')) {
      api.createRecord('bc5e9a46', component.options)
    } else {
      api.reload('bc5e9a46', component.options)
    }
    module.hot.accept("./ItemPanel.vue?vue&type=template&id=bc5e9a46&", function () {
      api.rerender('bc5e9a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/ItemPanel.vue"
export default component.exports